export default function USAVisaConsultants() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-10">

                {/* Main Heading */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Shivasya – Trusted USA Student Visa Consultants in Ahmedabad
                </h3>

                {/* Introduction */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <p>
                        Planning to study in the USA can feel overwhelming — from selecting the
                        right course and university to completing visa documentation and preparing
                        for interviews. Shivasya Education and Immigration Services provides
                        complete guidance to students at every stage of the U.S. student visa process,
                        ensuring a smooth and stress-free experience.
                    </p>

                    <p>
                        With years of expertise and a student-first approach, we help aspirants
                        successfully navigate complex visa procedures while improving their
                        approval chances.
                    </p>
                </div>

                {/* Services Heading */}
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900">
                    Our USA Student Visa Services Include:
                </h4>

                {/* Service Sections */}

                {/* 1 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">1. Personalized Visa Planning</h5>
                    <p>
                        We create a structured visa application timeline, guide students in
                        gathering required documents, and ensure deadlines are met so they
                        can enroll in their academic program without delays.
                    </p>
                </div>

                {/* 2 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">2. SEVIS Fee Guidance</h5>
                    <p>
                        The SEVIS (Student and Exchange Visitor Information System) fee
                        is an essential part of the visa process. We clarify its purpose,
                        check eligibility for waivers (if applicable), and guide students
                        through the correct payment procedure.
                    </p>
                </div>

                {/* 3 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">3. DS-160 Form Assistance</h5>
                    <p>
                        Completing the DS-160 online nonimmigrant visa application requires
                        accuracy and attention to detail. Our experts ensure the form is filled
                        correctly to prevent mistakes that may negatively impact the visa interview.
                    </p>
                </div>

                {/* 4 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">4. Student Visa Interview Preparation</h5>
                    <p>
                        We assist in scheduling interviews at the nearest U.S. Embassy or
                        Consulate and conduct mock interview sessions. Our guidance helps
                        students answer confidently, truthfully, and clearly during this
                        crucial stage of the visa process.
                    </p>
                </div>

                {/* 5 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">5. Visa Denial Assistance</h5>
                    <p>
                        If a visa has been denied previously, we carefully analyze the
                        reasons, rectify documentation errors, and conduct intensive
                        mock interviews to strengthen reapplication chances and improve
                        overall case presentation.
                    </p>
                </div>

                {/* 6 */}
                <div className="space-y-3 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <h5 className="font-semibold text-gray-900">6. Post-Visa Support</h5>
                    <p>
                        After visa approval, we guide students on travel preparation,
                        legal formalities, and academic regulations in the USA to ensure
                        a smooth transition and minimal challenges upon arrival.
                    </p>
                </div>

                {/* Why Choose */}
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900">
                    Why Choose Shivasya?
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <p>
                        Shivasya has successfully assisted hundreds of students in achieving
                        their dream of studying in the USA. Our comprehensive and personalized
                        approach ensures every stage — from documentation to post-visa support —
                        is handled professionally.
                    </p>

                    <p>
                        We focus on reducing stress, avoiding errors, and increasing visa
                        success rates through structured guidance and expert consultation.
                    </p>

                    <p className="font-semibold text-gray-900">
                        Contact Shivasya Education and Immigration Services today to schedule
                        your consultation and take the first confident step toward your
                        U.S. study journey.
                    </p>
                </div>

            </div>
        </section>
    );
}